// extracted by mini-css-extract-plugin
export default {"svgContainer":"SvgContainer5_svgContainer__aZ4RV","blackSvg":"SvgContainer5_blackSvg__HYbau"};